export default "<app-login></app-login>\r\n";